import { styled } from '@mui/material/styles'
import {
  Dialog,
  DialogTitle,
  List,
  Box,
  Chip,
  IconButton,
  Typography,
} from '@mui/material'
import EventNoteIcon from '@mui/icons-material/EventNote'
import ReplyIcon from '@mui/icons-material/Reply'

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 16,
    maxWidth: 600,
    width: '100%',
    margin: theme.spacing(2),
    background: 'rgba(255, 255, 255, 0.98)',
    backdropFilter: 'blur(20px)',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      borderRadius: 12,
    },
  },
}))

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5, 2),
  },
}))

export const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  '& .MuiListItem-root': {
    paddingLeft: 0,
    paddingRight: 0,
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  '& .MuiListItemButton-root': {
    borderRadius: 8,
    marginBottom: 1,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))

export const DialogContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}))

export const StyledEventNoteIcon = styled(EventNoteIcon)(({ theme }) => ({
  fontSize: 48,
  opacity: 0.5,
  marginBottom: theme.spacing(1),
}))

export const EmptyState = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',
  gap: theme.spacing(1),
  color: theme.palette.text.secondary,
}))

export const StatusChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== '$bgColor',
})<{ $bgColor: string }>(({ $bgColor }) => ({
  background: $bgColor,
  color: 'white',
  fontWeight: 600,
  fontSize: 11,
  height: 20,
  borderRadius: 6,
  cursor: 'pointer',
  '.MuiChip-label': {
    paddingLeft: 6,
    paddingRight: 6,
  },
}))

export const StyledBackButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  borderRadius: 6,
  color: 'white',
  opacity: 0.7,
  padding: `4px 6px 4px 4px`,
  boxShadow: 'none',
  backgroundColor: theme.palette.primary.main,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    boxShadow: 'none',
    background: theme.palette.primary.dark,
  },
}))

export const StyledArrowBackIcon = styled(ReplyIcon)(({ theme }) => ({
  fontSize: 16,
}))

export const BackToRoomText = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 500,
  color: 'white',
  zIndex: 1000,
}))
